import { createSlice } from "@reduxjs/toolkit";

export const reduxPayment = createSlice({
    name: 'name_reduxPayment',//변경해도 의미 없네 (내부적으로 식별 용도인 듯)
    initialState: {
        isSelectedTab_home: 0,
        orderList: {   
            id: null,
            stCode: null,
            email: null,
            name: null,
            bookName: null,
            isbn: null,
            productCode: null,
            price: 0,
        }
       
    },
    
    reducers: {

        setIsSelectedTab_home: (state, action) => {
            state.isSelectedTab_home = action.payload;
        },
        setOrderList: (state, action) => {
            state.orderList = { ...state.orderList, ...action.payload };
        },

    
     
    }


});



export const { 
    setIsSelectedTab_home, 
    setOrderList,

   
} = reduxPayment.actions;

export default reduxPayment.reducer;

